// Single source of truth for environment variables
// Crash-proof and CRA compatible

const FALLBACK_API = "http://localhost:10000/api";

let API_URL = FALLBACK_API;

try {
  if (
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_API_URL
  ) {
    API_URL = process.env.REACT_APP_API_URL;
  }
} catch (e) {
  API_URL = FALLBACK_API;
}

export { API_URL };
